import { render, staticRenderFns } from "./FormTemplateQuestion.vue?vue&type=template&id=2fe88ef0&scoped=true&"
import script from "./FormTemplateQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateQuestion.vue?vue&type=style&index=0&id=2fe88ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe88ef0",
  null
  
)

export default component.exports